export default "__VITE_ASSET__aOwjcFYF__"